import { C } from "../constants";

export default function Pill({ label, color = C.muted }) {
  return (
    <span style={{
      display: "inline-block", padding: "2px 10px", borderRadius: 20,
      border: `1px solid ${color}`, color, fontSize: 11, fontWeight: 600,
      letterSpacing: 0.5, marginRight: 6,
    }}>
      {label}
    </span>
  );
}
